import { motion } from "framer-motion";
import { YT_VIDEO_ID, socialLinks } from "@/data/products";

export default function VideoSection() {
  return (
    <section
      id="video"
      className="relative bg-[#1a1412] py-28 md:py-40 border-t border-[#362b28]"
      data-testid="video-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-6 mb-12 md:mb-16 items-end">
          <div className="col-span-12 md:col-span-8">
            <motion.p
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              className="eyebrow mb-6"
            >
              Watch · God&rsquo;s Fingerprint
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, ease: [0.19, 1, 0.22, 1] }}
              className="font-serif text-[36px] md:text-[58px] leading-[1] tracking-tight text-[#e8dcc4]"
            >
              <em className="italic text-[#c28b46]">The truth</em> about who you are —
              <br className="hidden md:block" /> and what&rsquo;s been inside you all along.
            </motion.h2>
          </div>

          <motion.a
            href={socialLinks.youtube}
            target="_blank"
            rel="noopener noreferrer"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.15 }}
            className="hidden md:inline-flex col-span-12 md:col-span-4 justify-self-end items-center gap-3 px-5 py-3 border border-[#c28b46] text-[#c28b46] hover:bg-[#c28b46] hover:text-[#1a1412] transition-colors text-[11px] tracking-[0.22em] uppercase font-semibold"
            data-testid="video-channel-link-top"
          >
            <YouTubeIcon />
            @EarthToneArchetypes
            <span aria-hidden>→</span>
          </motion.a>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.19, 1, 0.22, 1] }}
          className="relative border border-[#362b28] bg-black shadow-[0_60px_120px_-40px_rgba(0,0,0,0.8)]"
          data-testid="video-embed"
        >
          <div className="relative w-full aspect-video">
            <iframe
              src={`https://www.youtube-nocookie.com/embed/${YT_VIDEO_ID}?rel=0&modestbranding=1`}
              title="The Secret Power of Melanin — God's Fingerprint"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              className="absolute inset-0 w-full h-full"
            />
          </div>
          <div className="absolute -top-3 -left-3 border-t border-l border-[#c28b46] w-10 h-10 pointer-events-none" />
          <div className="absolute -bottom-3 -right-3 border-b border-r border-[#c28b46] w-10 h-10 pointer-events-none" />
        </motion.div>

        {/* Subscribe / Channel CTA — under the video */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.9, delay: 0.1 }}
          className="mt-10 md:mt-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-5"
        >
          <p className="text-[13px] md:text-[15px] leading-relaxed text-[#c8b99c] max-w-[52ch]">
            Every week I drop another chapter — the science, the scripture, the
            ancient history of the <em className="text-[#e8dcc4]">EarthTone</em> people.
            Subscribe so you don&rsquo;t miss the next one.
          </p>

          <a
            href={socialLinks.youtube}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#c62828] hover:bg-[#e03535] text-[#f5ebd8] px-6 py-4 text-[11px] md:text-[12px] tracking-[0.22em] uppercase font-semibold border border-[#c62828] shadow-[0_20px_50px_-15px_rgba(198,40,40,0.5)]"
            data-testid="video-subscribe-cta"
          >
            <YouTubeIcon />
            Subscribe on YouTube
            <span aria-hidden>→</span>
          </a>
        </motion.div>
      </div>
    </section>
  );
}

function YouTubeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className="w-4 h-4 md:w-[18px] md:h-[18px] shrink-0"
      fill="currentColor"
      aria-hidden
    >
      <path d="M23.498 6.186a2.998 2.998 0 0 0-2.11-2.122C19.44 3.5 12 3.5 12 3.5s-7.44 0-9.388.564A2.998 2.998 0 0 0 .502 6.186 31.245 31.245 0 0 0 0 12a31.245 31.245 0 0 0 .502 5.814 2.998 2.998 0 0 0 2.11 2.122C4.56 20.5 12 20.5 12 20.5s7.44 0 9.388-.564a2.998 2.998 0 0 0 2.11-2.122A31.245 31.245 0 0 0 24 12a31.245 31.245 0 0 0-.502-5.814ZM9.75 15.568V8.432L15.818 12l-6.068 3.568Z" />
    </svg>
  );
}
